import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { isExist } from "cxa-utils";
import messages from "components/messagesDescription";
import { renderAsHTML } from "../../../utils";
const {
  planYearDescription,
  periodDescription,
  employeeIdDescription,
  nameDescription,
  accountOwnerDescription,
  statementDateDescription,
} = messages;

const PlanHeader = ({ user, account, intl, pageFields }) => {
  const { planName, periodStart, periodEnd, employeeId, owner } = account;
  const { employee } = user;

  // NOTE: for ocbc
  const period = pageFields.find(({ fieldID }) => {
    const lowerCaseFieldID = fieldID.toLowerCase();

    return lowerCaseFieldID === "period";
  });
  const shouldDisplayPeriod = isExist(period, periodStart, periodEnd);

  return (
    <table className="table--minimal">
      <tbody>
        <tr>
          <th>{intl.formatMessage(planYearDescription)}:</th>
          <td>
            {intl.formatMessage({
              id: planName,
              defaultMessage: planName,
            })}
          </td>
        </tr>

        {shouldDisplayPeriod && (
          <tr>
            <th>{intl.formatMessage(periodDescription)}:</th>
            <td>{`${moment(periodStart).format()} - ${moment(periodEnd).format()}`}</td>
          </tr>
        )}

        <tr>
          <th>{intl.formatMessage(employeeIdDescription)}:</th>
          <td>{employeeId}</td>
        </tr>

        <tr>
          <th>{intl.formatMessage(nameDescription)}</th>
          <td>{renderAsHTML("span", employee.fullName)}</td>
        </tr>

        <tr>
          <th>{intl.formatMessage(accountOwnerDescription)}: </th>
          <td>{renderAsHTML("span", owner)}</td>
        </tr>

        <tr>
          <th>{intl.formatMessage(statementDateDescription)}:</th>
          <td>{moment(new Date()).format()}</td>
        </tr>
      </tbody>
    </table>
  );
};

PlanHeader.propTypes = {
  intl: PropTypes.object.isRequired,
  account: PropTypes.object.isRequired,
  user: PropTypes.object,
  pageFields: PropTypes.array,
};

PlanHeader.defaultProps = {
  pageFields: [],
};

export default PlanHeader;



// WEBPACK FOOTER //
// ./components/claim/widgets/PlanHeader.jsx